export default "__VITE_ASSET__DOOYroFc__"